import React from "react";
import {useSelector} from "react-redux";

export default function CreditsTable({data}){
    const accountData = useSelector((state) => state.rootReducer.techsbookSlice.userData);
    return (
        <div className="credits_table_content">
            <table>
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Date</th>
                        <th>Job ID</th>
                        <th>Status</th>
                        <th>Amount</th>
                    </tr>
                </thead>
                <tbody>
                {
                    data?.map((transaction) => {
                        const amount = transaction.amount;
                        const status = amount > 0 ? 'Income' : 'Outcome'
                        return (
                            <tr>
                                <td>{transaction?.id}</td>
                                <td>{transaction?.created_at}</td>
                                <td>{transaction?.job_id}</td>
                                <td>
                                    <span className={`credits_table_content_${status.toLowerCase()}`}>{status}</span>
                                </td>
                                <td>
                                    {amount < 0
                                        ? `-${accountData?.country_currency_sign}${Math.abs(amount)}`
                                        : `${accountData?.country_currency_sign}${amount}`}
                                </td>
                            </tr>
                        )
                    })
                }
                </tbody>
            </table>
        </div>
    )
}